import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import { getPageProps } from "@services/initial-calls";
import { useDomainContext } from "@hooks/useDomainContext";
import SeveralBrandsWrapper from "@components/layouts/severalBrandsWrapper";
import { DomainInfo } from "@components/severalbrands/utils/services";
import BusinessPhoneSystemsContainer from "@components/severalbrands/businessPhoneSystemsComponents";
import FleetManagementContainer from "@components/severalbrands/fleetManagementComponents";
import CrmContainer from "@components/severalbrands/crmComponents";
import CreditCardProcessingContainer from "@components/severalbrands/creditCardProcessingComponents";
import ForkLiftsContainer from "@components/severalbrands/forkliftsComponents";
import PointOfSaleContainer from "@components/severalbrands/pointOfSaleComponents";
import PayrollContainer from "@components/severalbrands/payrollComponents";
import PeoContainer from "@components/severalbrands/peoComponents";
import MedicalSoftwareContainer from "@components/severalbrands/medicalSoftwareComponents";
import DigitalCopierContainer from "@components/severalbrands/digitalCopierComponents";
import WideFormatPrintersContainer from "@components/severalbrands/wideFormatPrintersComponents";

const b2bCategorySlugs = [
    "sb-fleet-management",
    "fleet-management",
    "sb-business-phone-systems",
    "business-phone-systems",
    "sb-crm",
    "crm",
    "sb-credit-card-processing",
    "credit-card-processing",
    "sb-forklifts",
    "forklifts",
    "sb-point-of-sale",
    "point-of-sale",
    "sb-payroll",
    "payroll",
    "sb-peo-employee-leasing",
    "peo",
    "sb-medical-software",
    "medical-software",
    "sb-digital-copier",
    "sb-wide-format-printers",
];

export default function SeveralBrandsCategoryPage(): ReactElement {
    const { domain, category } = useDomainContext();
    let content;
    switch (category?.slug) {
        case "sb-fleet-management":
        case "fleet-management":
            content = <FleetManagementContainer />;
            break;
        case "sb-business-phone-systems":
        case "business-phone-systems":
            content = <BusinessPhoneSystemsContainer />;
            break;
        case "sb-crm":
        case "crm":
            content = <CrmContainer />;
            break;
        case "sb-credit-card-processing":
        case "credit-card-processing":
            content = <CreditCardProcessingContainer />;
            break;
        case "sb-forklifts":
        case "forklifts":
            content = <ForkLiftsContainer />;
            break;
        case "sb-point-of-sale":
        case "point-of-sale":
            content = <PointOfSaleContainer />;
            break;
        case "sb-payroll":
        case "payroll":
            content = <PayrollContainer />;
            break;
        case "sb-peo-employee-leasing":
        case "peo":
            content = <PeoContainer />;
            break;
        case "sb-medical-software":
        case "medical-software":
            content = <MedicalSoftwareContainer />;
            break;
        case "sb-digital-copier":
            content = <DigitalCopierContainer />;
            break;
        case "sb-wide-format-printers":
            content = <WideFormatPrintersContainer />;
            break;
    }
    return (
        <SeveralBrandsWrapper domainInfo={domain as DomainInfo}>
            {content}
        </SeveralBrandsWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    const result = await getPageProps(context, "category", {
        getDomainMenus: true,
    });
    if (
        "props" in result &&
        !b2bCategorySlugs.includes(
            ((result.props as { category?: { slug?: string } }).category
                ?.slug as string) ?? "",
        )
    ) {
        return { notFound: true };
    }
    return result;
};
